import {
  AttachmentDataComponentConfig,
  AttachmentsDataSectionComponent
} from '../common/attachments-data-section/attachments-data-section.component';
import {Routes} from '@angular/router';
import {
  GeneralLetterInformationSectionComponent
} from './section/general-letter-information-section/general-letter-information-section.component';
import {
  GeneralLetterApplicantDataSectionComponent
} from './section/general-letter-applicant-data-section/general-letter-applicant-data-section.component';
import {
  AgreementsDataComponentConfig,
  AgreementsDataSectionComponent
} from '../common/agreements-data-section/agreements-data-section.component';
import {SessionService} from '../../../../services/ssession.service';

export const desktopStages: string[] = [
  'Informacje podstawowe',
  'Dane identyfikacyjne',
  'Zgody',
  'Załączniki'
];

export const mobileStages: string[] = [
  'Informacje podstawowe',
  'Dane identyfikacyjne',
  'Zgody',
  'Załączniki'
];

export const stages: string[] = SessionService.GetUISettings()?.mobileEmbed ? mobileStages : desktopStages;

export const agreementsDataSectionConfig: AgreementsDataComponentConfig = {
  stages,
  cancelUrl: '../dane-identyfikacyjne',
  successUrl: '../zalaczniki'
};

export const attachmentDataSectionConfig: AttachmentDataComponentConfig = {
  stages,
  cancelUrl: '../zgody'
};

export const generalLetterDesktopRoutes: Routes = [
  {
    component: GeneralLetterInformationSectionComponent,
    path: 'informacje-podstawowe'
  },
  {
    component: GeneralLetterInformationSectionComponent,
    path: ':appId/informacje-podstawowe'
  },
  {
    component: GeneralLetterApplicantDataSectionComponent,
    path: ':appId/dane-identyfikacyjne',
    data: {
      successUrl: '../zgody'
    }
  },
  {
    path: ':appId/zgody',
    component: AgreementsDataSectionComponent,
    data: agreementsDataSectionConfig
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  {path: '', redirectTo: 'informacje-podstawowe', pathMatch: 'prefix'}
];

export const generalLetterMobileRoutes: Routes = [
  {
    component: GeneralLetterInformationSectionComponent,
    path: 'informacje-podstawowe'
  },
  {
    component: GeneralLetterInformationSectionComponent,
    path: ':appId/informacje-podstawowe'
  },
  {
    component: GeneralLetterApplicantDataSectionComponent,
    path: ':appId/dane-identyfikacyjne',
    data: {
      successUrl: '../zgody'
    }
  },
  {
    path: ':appId/zgody',
    component: AgreementsDataSectionComponent,
    data: {
      ...agreementsDataSectionConfig,
      removeRegulationsControl: true
    }
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  {path: '', redirectTo: 'informacje-podstawowe', pathMatch: 'prefix'}
];

export const generalLetterRoutes: Routes = SessionService.GetUISettings()?.mobileEmbed ? generalLetterMobileRoutes : generalLetterDesktopRoutes;
